import { ProductSku } from "@sveabank/cc-common";
import { useFetchPackagesQuery, useFetchSelectedPackageQuery } from "../services/package";
import { isSelectedProductCreditProduct } from "../types/product";
import { useApplicationId } from "./useApplicationId";

export const usePackage = () => {
	const applicationId = useApplicationId();

	const {
		data: availablePackages,
		isError: availablePackagesIsError,
		isLoading: availablePackagesIsLoading,
	} = useFetchPackagesQuery(applicationId);

	const {
		data: selectedPackageData,
		isError: selectedPackageDataIsError,
		isLoading: selectedPackageDataIsLoading,
	} = useFetchSelectedPackageQuery(applicationId);

	const selectedProducts = selectedPackageData?.products;
	const selectedPackageId = selectedPackageData?.packageId;
	const selectedAddons = selectedProducts?.filter((s) => s.isAddon) || [];
	const selectedStandardProducts = selectedProducts?.filter((s) => !s.isAddon) || [];
	const selectedCreditProducts = selectedProducts?.filter(isSelectedProductCreditProduct) || [];
	const selectedPackage = availablePackages?.find((p) => p?.packageId === selectedPackageId);
	const selectedPackageFee = selectedPackageData?.monthlyFee.amount;
	const hasCreditProduct = Boolean(selectedCreditProducts.length);
	const hasCheckCreditProduct = Boolean(
		selectedProducts?.find((s) => s.sku === ProductSku.CheckCredit),
	);
	const creditAssessment = selectedPackageData?.assessment;

	const checkCreditProductBrackets = () => {
		const isCheckCreditAddon = !!selectedProducts?.find(
			(product) => product.productDefinitionId === "CHECKKREDIT" && product.isAddon,
		);

		if (!selectedPackage) return null;
		if (!availablePackages) return null;

		return (
			(isCheckCreditAddon ? selectedPackage.addons : selectedPackage.products).find(
				(p) => p.definitionId === "CHECKKREDIT",
			)?.config || null
		);
	};

	return {
		selectedPackageData,
		selectedPackageDataIsError,
		selectedPackageDataIsLoading,
		selectedPackage,
		selectedPackageId,
		selectedPackageFee,
		selectedProducts,
		selectedAddons,
		selectedStandardProducts,
		selectedCreditProducts,
		hasCreditProduct,
		hasCheckCreditProduct,
		availablePackages,
		availablePackagesIsLoading,
		availablePackagesIsError,
		creditAssessment,
		checkCreditProductBrackets,
	};
};
